import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Button, Col, Row, Space, Tooltip } from "antd";
import { ControlOutlined, PlusCircleOutlined } from "@ant-design/icons";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useTranslation } from "react-i18next";
import { ColumnsType } from "antd/lib/table";
import { NumberInfo } from "ant-design-pro";
import Stat from "../../../components/Stat";
import EditFieldOpex from "../../../components/OpexActions/edit";
import FieldValueHistoryModalOpex from "../../Opex/FieldValueHistoryModalOpex";
import { IConfig, IhistoryConfig } from "../../Opex";
import api from "../../../services/api";
import { useToast } from "../../../hooks/toast";
import Table from "../../../components/Table";
import AddAllocationModal from "./AllocationModal";
import UserAvatar from "../../../components/UserAvatar";

export interface IAllocation {
  id: string;
  name_user: string;
  avatar_url_user: string;
  percentage: number;
  total: number;
  user_id: string;
}

const AllocationRectability: React.FC = (): JSX.Element => {
  const [loading, setLoading] = useState(false);
  const [historyConfig, setHistoryConfig] = useState<IhistoryConfig[]>([]);
  /*  const [historyConfigHours, setHistoryConfigHours] = useState<
    IhistoryConfig[]
  >([]); */
  const [config, setConfig] = useState<IConfig[]>([]);
  /* const [configHours, setConfigHours] = useState<IConfig[]>([]);
   */ const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [editedAllocation, setEditedAllocation] = useState<
    IAllocation | undefined
  >();
  const [rectabilityAllocation, setRectabilityAllocation] = useState<
    IAllocation[]
  >([]);
  const { t } = useTranslation(["rectability", "config"]);
  const { addToast } = useToast();
  const handleConfig = useCallback((conf: IConfig[]) => {
    setConfig(conf);
    if (conf[0]?.history_config) {
      const his = conf[0]?.history_config;
      setHistoryConfig(his);
    }
  }, []);
  /* const handleConfigHours = useCallback((conf: IConfig[]) => {
    setConfigHours(conf);
    if (conf[0]?.history_config) {
      const his = conf[0]?.history_config;
      setHistoryConfigHours(his);
    }
  }, []); */
  const generateErrorToast = useCallback(
    (response: AxiosResponse | undefined, isDeleting?: boolean) => {
      let description;

      switch (response?.status) {
        case 403:
          description = t("requestError.403");
          break;
        case 401:
          description = t("requestError.401");
          break;
        case 404:
          description = t("requestError.404");
          break;
        case 409:
          description = t("requestError.409");
          break;
        default:
          description = isDeleting
            ? t("requestError.delete")
            : t("requestError.get");
      }
      if (!isDeleting) {
        addToast({
          type: "error",
          title: isDeleting
            ? t("allocation.requestEq.deleteStatus")
            : t("allocation.requestEq.getStatus"),
          description,
        });
      }
    },
    [addToast, t],
  );
  const handleCloseModal = useCallback(
    (editAll?: IAllocation[]) => {
      setEditedAllocation(undefined);
      if (editAll) {
        const a = editAll.map(usr => {
          const newNumber = new Intl.NumberFormat("pt-BR");

          return { ...usr, total: newNumber.format(Number(usr.total)) };
        });
        setRectabilityAllocation((a as unknown) as IAllocation[]);
        // eslint-disable-next-line no-shadow
      }
      setModalVisible(false);
    },
    [rectabilityAllocation],
  );
  /* const handleEdit = useCallback((configE: IAllocation) => {
    if (configE) {
      setEditedAllocation(configE);
    }
    setModalVisible(true);
  }, []); */
  useEffect(() => {
    setLoading(true);
    api
      .get<IConfig>("/configurations", {
        params: {
          name: "INTEREST_RATE",
        },
      })
      .then(response => {
        setConfig([response.data]);
        const his = response.data.history_config as IhistoryConfig[];
        setHistoryConfig(his);
      })
      .catch(err => {
        if (axios.isAxiosError(err)) {
          const serverError = err as AxiosError;
          generateErrorToast(serverError.response, true);
        }
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalVisible, editedAllocation]);
  /* useEffect(() => {
    setLoading(true);
    api
      .get<IConfig>("/configurations", {
        params: {
          name: "VALUE_HOURS",
        },
      })
      .then(response => {
        setConfigHours([response.data]);
        const his = response.data.history_config as IhistoryConfig[];
        setHistoryConfigHours(his);
      })
      .catch(err => {
        if (axios.isAxiosError(err)) {
          const serverError = err as AxiosError;
          generateErrorToast(serverError.response, true);
        }
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalVisible, editedAllocation]); */
  useEffect(() => {
    setLoading(true);
    api
      .get<IAllocation[]>("/allocation")
      .then(response => {
        const a = response.data.map(usr => {
          const newNumber = new Intl.NumberFormat("pt-BR");

          return { ...usr, total: newNumber.format(Number(usr.total)) };
        });
        setRectabilityAllocation((a as unknown) as IAllocation[]);
      })
      .catch(err => {
        if (axios.isAxiosError(err)) {
          const serverError = err as AxiosError;
          generateErrorToast(serverError.response);
        }
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config]);
  const columnsOpexs: ColumnsType<IAllocation> = [
    {
      title: t("allocation.name"),
      dataIndex: "name_user",
    },
    {
      title: t("allocation.avatar"),
      dataIndex: "avatar_url_user",
      render: (url: string, record) => {
        return record.name_user ? (
          <UserAvatar name={record?.name_user || ""} url={url} size={36} />
        ) : (
          <></>
        );
      },
    },
    {
      title: t("allocation.porcentagem"),
      dataIndex: "percentage",
      render: porcentagem => `${porcentagem}%`,
    },
    {
      title: t("allocation.total"),
      dataIndex: "total",
    },
    /*  {
      title: "Ações",
      dataIndex: "actions",
      fixed: "right",
      render: (_, record) => (
        <>
          <Button
            icon={<EditOutlined />}
            type="link"
            onClick={() => handleEdit(record)}
          />
        </>
      ),
    }, */
  ];
  const extraActionOpex = useMemo(() => {
    return (
      <Tooltip title={t("allocation.add")}>
        <Button
          icon={<PlusCircleOutlined />}
          type="link"
          size="large"
          onClick={() => setModalVisible(true)}
        />
      </Tooltip>
    );
  }, [t]);
  return (
    <>
      <AddAllocationModal
        visible={modalVisible}
        handleCloseModal={handleCloseModal}
        opex={editedAllocation}
        state={rectabilityAllocation}
      />
      <Space
        direction="vertical"
        size="middle"
        style={{ display: "flex", marginBottom: "20px" }}
      >
        <Row gutter={[12, 12]}>
          <Col xs={24} lg={8}>
            <Stat
              title={t("allocation.config.title")}
              value={`${config[0]?.value ? config[0].value : 18}`}
              icon={<ControlOutlined />}
              loading={loading}
              editComponent={
                config ? (
                  <EditFieldOpex
                    fieldName="EditFieldOpex"
                    opexUpdate={config[0]}
                    handleConfig={conf => handleConfig(conf)}
                    title={t("allocation.config.title")}
                    type_config="INTEREST_RATE"
                  />
                ) : (
                  <></>
                )
              }
              valueHistoryComponent={
                historyConfig ? (
                  <FieldValueHistoryModalOpex
                    configData={historyConfig as IhistoryConfig[]}
                    title={t("allocation.config.title")}
                  />
                ) : (
                  <></>
                )
              }
            />
          </Col>
          {/* <Col xs={24} lg={8}>
            <Stat
              title={t("allocation.configHours.title")}
              value={`${configHours[0]?.value ? configHours[0].value : ""}`}
              icon={<ControlOutlined />}
              loading={loading}
              editComponent={
                config ? (
                  <EditFieldOpex
                    fieldName="EditFieldOpex"
                    opexUpdate={configHours[0]}
                    handleConfig={conf => handleConfigHours(conf)}
                    title={t("allocation.configHours.title")}
                    type_config="VALUE_HOURS"
                  />
                ) : (
                  <></>
                )
              }
              valueHistoryComponent={
                historyConfigHours ? (
                  <FieldValueHistoryModalOpex
                    configData={historyConfigHours as IhistoryConfig[]}
                    title={t("allocation.configHours.title")}
                  />
                ) : (
                  <></>
                )
              }
            />
          </Col> */}
        </Row>
      </Space>
      <Table
        data={rectabilityAllocation || []}
        columns={columnsOpexs}
        title={<>{t("allocation.title")}</>}
        extraActions={extraActionOpex}
        footer={() => <></>}
        loading={loading}
        pagination={false}
        extraFilters={<></>}
      />
    </>
  );
};

export default AllocationRectability;
